/* istanbul ignore file */
import styled from 'styled-components';
import { MenuButton } from '@econsult/econsult-ui/dist/components/TopBar/TopBarStyles';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { FlexDiv } from 'components/Div/styles';

export const TopBarBox = styled(FlexDiv)`
  flex: 1 1 auto;
  position: relative;
  outline: none;
`;

export const RightBarContainer = styled(FlexDiv)`
  height: 100%;
  align-items: center;
  border-right: 1px solid rgb(75, 71, 111);
  margin-right: 17px;
  padding-right: 12px;
`;

export const LogoTitleGroup = styled(FlexDiv)`
  align-items: center;
  gap: 8px;
  padding: 0 20px;
  color: #FFFFFF;
`;

export const TopBarWrapper = styled(FlexDiv)`
  flex: 1 1 auto;
  height: 56px;
  z-index: 4;
  box-sizing: border-box;
`;

export const FeedbackButton = styled(Button).attrs(({ id, children }) => ({
  id: id || `button-${children?.toString().toLowerCase().replace(/\s+/g, '-')}`,
}))`
  height: 28px;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  background: ${({ theme }) => theme.colorSecondarySecondary100};
  border-color: ${({ theme }) => theme.colorSecondarySecondary100};
`;

export const MenuButtonContainer = styled(MenuButton)`
  background-color: transparent;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 2rem;
  &:hover {
    color: ${({ theme }) => theme.headerHoverFontColor};
    background-color: ${({ theme }) => theme.headerHoverColor};
  }
  &:focus {
    color: ${({ theme }) => theme.headerHoverFontColor};
    background-color: ${({ theme }) => theme.headerHoverColor};
    outline: none;
    border-radius: 0;
  }
`;

export const TopBarMiddleContainer = styled(FlexDiv)`
  align-items: center;
  justify-content: flex-start;
  flex: 1;
`;
